const { UserService } = window.MiniService;
const env = process.env.VUE_APP_ENV === 'prod' ? 10 : 11;
const logURL = process.env.VUE_APP_BASE_LOG_URL

function reportHandle(options = {}) {
  const { uin = '', ver = '', country = '', lang = '' } = UserService.getUserInfo() || {}

  const commonParams = {
    ts: Math.floor(new Date().getTime() / 1000),
    uin,
    version: ver,
    country,
    lang,
    platform: '',
    channel: '',
    ip: '__IP__',
    session_id: ''
  }

  const resultOptions = Object.assign(commonParams, {
    env, // env  环境标识  "国内" -> 0, "测试" -> 1, "先遣服" -> 2, "海外" -> 10, "海外测试" -> 11
    id: '71001', // 同业务id，生成文件名作用
    product: '71001', // 业务id，如商业化活动，增长相关
    activity: '10001', // 活动场景， 活动ID
    event_type: 'view', // 事件类型，view 浏览；click 点击；enter 输入;
    scene_comp: 'FrontPage' // 场景组件
  }, options)

  navigator.sendBeacon(logURL, `json3=[${JSON.stringify(resultOptions)}]`)
}

function makeEvent(product, activity) {
  const _getOptionsHandle = (options, scene_comp, event_type) => {
    return reportHandle({ ...options, id: product, product, activity, scene_comp, event_type })
  }

  return {
    view: (scene_comp, options = {}) => _getOptionsHandle(options, scene_comp, 'view'),
    click: (scene_comp, options = {}) => _getOptionsHandle(options, scene_comp, 'click'),
    enter: (scene_comp, options = {}) => _getOptionsHandle(options, scene_comp, 'enter'),
    success: (scene_comp, options = {}) => _getOptionsHandle(options, scene_comp, 'success')
  }
}

export default makeEvent
